export const operationPositions = {
  PREVIOUS: 'Previous',
  NEXT: 'Next',
};
